const getLocation = (callback = null) => {
  navigator.geolocation.getCurrentPosition((position) => {
    const location = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };

    callback && callback(location);
  });
};

export default getLocation;
